/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  if (window.location.href.indexOf('cart') > -1) {
    window.location.href = '/';
  }

  // Check if URL has ?freetoy parameter
  const urlParams = new URLSearchParams(window.location.search);
  const hasFreeToyCoupon = urlParams.has('freetoy');
  const giftLineItem = document.querySelectorAll('[data-freetoy-gift]');

  if (hasFreeToyCoupon && giftLineItem.length === 0) {
    const formData = new FormData();

    document.cookie = "free_gift_added=true; path=/; max-age=" + 60 * 60 * 24 * 30;


    formData.append('id', 47382751707386); // Free toy variant ID
    formData.append('quantity', 1);
    //document.querySelectorAll('.reward-block')[0].classList.add('reward-block--selectedd')

    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        detail: {
          freeGift: true,
          giftFormData: formData,
        },
        bubbles: false,
      })
    );
  }

  // Init Yotpo back in stock
  window.addEventListener('theme:variant:change', (e) => {
    if (window.smsBumpBackInStock) {
      window.smsBumpBackInStock.changeSelectedVariant(e.detail.variant.id);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
